module.exports = __webpack_public_path__ + "static/media/logout-dark.d2c28f20.svg";